import { XMarkIcon } from '@heroicons/react/20/solid';
import React from 'react';
import { connect } from 'react-redux';
import { Actions } from '../../../store/actions/employeeActions';
import AttachmentPaymentRow from './AttachmentPaymentRow';
import { orderBy } from 'lodash';
import DownloadForms from '../DownloadForms';

const PaymentHistoryModal = ({
    closeModal,
    modalOpen,
    payments,
    agreement,
    adjustmentId,
    currency,
}) => {

    if (!modalOpen) return null


    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}>
            <div className="modal-dialog" style={{ width: "75%" }}>
                <div className="modal-content">
                    <div className="block block-themed block-transparent remove-margin-b" style={{ padding: 0 }}>
                        <div className="block-header bg-primary-dark" style={{ padding: 20, position: 'sticky', top: 0, zIndex: 50 }}>
                            <ul className="block-options">
                                <li>
                                    <button type="button" onClick={closeModal}><XMarkIcon className="h-6 w-6 mr-3 text-white" /></button>
                                </li>
                            </ul>
                            <h3 className="block-title">Payment History</h3>
                        </div>
                        <div className="block-content" style={{ marginLeft: '2rem', marginRight: '2rem' }}>
                            <div className='col-xs-12 form-section'>

                                <div className='col-xs-3 section-header'>
                                    <h1>Payments</h1>
                                </div>
                                <div className='col-xs-9 section-header'>
                                    <DownloadForms {...{ formType: 'direct attachments', agreementId: agreement, adjustmentId}}/>
                                </div>
                                <div className='col-xs-12'>
                                    <div className='form-inner-section pr-0 pl-0'>
                                        <div
                                            style={{ display: "grid", gridGap: "1.5rem", grid: "1.5rem", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", padding: '1rem', borderBottom: 'solid rgb(244,244,244) 4px' }}>
                                            <div style={{ gridColumn: "span 1 / span 4", textAlign: 'center', opacity: '0.75' }}>
                                                <h5>Date</h5>
                                            </div>
                                            <div style={{ gridColumn: "span 1 / span 4", textAlign: 'center', opacity: '0.75' }}>
                                                <h5>Amount</h5>
                                            </div>
                                            <div style={{ gridColumn: "span 1 / span 4", textAlign: 'center', opacity: '0.75' }}>
                                                <h5>Note</h5>
                                            </div>
                                            <div style={{ gridColumn: "span 1 / span 4", textAlign: 'center', opacity: '0.75' }}>
                                                <h5></h5>
                                            </div>
                                        </div>
                                        {payments?.map((payment, index) => {
                                            const isLast = (index + 1) == payments.length
                                            return <AttachmentPaymentRow payment={payment} isLast={isLast} />
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='clearfix' />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    const { payments, paymentHistoryModal } = { ...state.employee?.attachmentEarnings }
    return {
        agreement: state.employee?.agreementInfo?.id,
        payments: payments ? orderBy(payments, ['date'], ['asc']) : [],
        modalOpen: !!paymentHistoryModal,
        adjustmentId: paymentHistoryModal,
        currency: state.company?.settings?.currency,
        disabled: (state?.permissions?.my?.permissions?.people == "Read"),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    closeModal: () => dispatch(Actions.togglePaymentHistoryModal({ open: false }))
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentHistoryModal);
